import { RoundedContainer } from '@/src/features/ui/rounded-container/rounded-container';
export default RoundedContainer;
